/** Landscape touch devices give multiple phase actions a separate line. */
export function shouldStackFortifyActions({ isLandscape, isDesktop, touchInput, showReturn }: {
  isLandscape: boolean
  isDesktop: boolean
  touchInput: boolean
  showReturn: boolean
}): boolean {
  return showReturn && isLandscape && (!isDesktop || touchInput)
}
